export enum LearnType {
    Integrations = 'integrations',
    Audience = 'audience',
    Monitoring = 'monitoring',
    LiveMessages = 'liveMessages',
    FormulaEditor = 'formulaEditor',
}

export interface LearnTypeDataModel {
    title: string;
    description: string;
    embedId: string;
}

export const LearnTypeData: { [key in LearnType]: LearnTypeDataModel } = {
    [LearnType.Integrations]: {
        title: 'Setting up your integrations',
        description:
            'Set up your push provider and app events in a few easy steps.',
        embedId: 'NvLd9t2uKTg',
    },
    [LearnType.Audience]: {
        title: 'Learn about your audience',
        description:
            'The Audience Explorer let’s you see how many users you have and subdivide them into user states based on their app activity.',
        embedId: 'ArKVUs34VQg',
    },
    [LearnType.Monitoring]: {
        title: 'A quick tour of the monitoring page',
        description:
            'Learn about critical messaging insights regarding sends, performance, frequency and timing personalization.',
        embedId: 'zpDnZubRSZo',
    },
    [LearnType.LiveMessages]: {
        title: 'Learn what’s really working',
        description:
            'One of the most powerful tools at Aampe, Live Message performance metrics allow you to get amazing insights.',
        embedId: '_RnIq6rGmN8',
    },
    [LearnType.FormulaEditor]: {
        title: 'Write your first message',
        description: 'Set up your first message in a few easy steps.',
        embedId: 'TChU5Ffa7T4',
    },
};
